import React from 'react';

import moment from 'moment';
import numeral from 'numeral';

import API from '../../../../utils/api';
import styles from './index.module.scss';

import baseball from '../../../../assets/images/BaseballBall-50.png';
import americano from '../../../../assets/images/AmericanoBall-50.png';
import futbol from '../../../../assets/images/FutbolBall-50.png';
import basketball from '../../../../assets/images/BasketballBall-50.png';
import hockey from '../../../../assets/images/Hockey.png';

const OldWagers = () => {
  const myGamesRef = React.useRef(null);
  const isLoadingRef = React.useRef(false);
  const currentPageRef = React.useRef(1);
  const scrollTimeoutRef = React.useRef(null);
  const hasInitialLoadRef = React.useRef(false);

  const [myBets, setMyBets] = React.useState([]);
  const [selectedStatus, setSelectedStatus] = React.useState('1');
  const [selectedRange, setSelectedRange] = React.useState('all');
  const [pager, setPager] = React.useState({
    page: 1,
    pages: 1,
    loading: true,
  });

  const handleChangeDropdown = e => {
    const status = document.getElementById('status').value;
    const range = document.getElementById('period').value;
    setMyBets([]);
    setSelectedStatus(status);
    setSelectedRange(range);
    isLoadingRef.current = false; // Resetear el flag de carga
    currentPageRef.current = 1; // Resetear la página de referencia
    hasInitialLoadRef.current = false; // Resetear para permitir nueva carga inicial
    // Limpiar timeout del scroll si existe
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
    }
    setPager({ page: 1, pages: 1, loading: true });
  };

  React.useEffect(() => {
    // Prevenir múltiples llamadas simultáneas para la misma página
    // Solo bloquear si ya está cargando Y es la misma página Y ya se hizo la carga inicial
    if (
      hasInitialLoadRef.current &&
      isLoadingRef.current &&
      currentPageRef.current === pager.page
    ) {
      return;
    }

    // Marcar que se intentó hacer la carga inicial
    if (!hasInitialLoadRef.current) {
      hasInitialLoadRef.current = true;
    }

    isLoadingRef.current = true;
    currentPageRef.current = pager.page;

    API.getUserWagersPariplay(pager.page, selectedStatus, selectedRange)
      .then(response => {
        const { page, pages, wagers } = response.data;

        // Si wagers está vacío, no agregar nada y detener la paginación
        if (!wagers || wagers.length === 0) {
          setPager({ page, pages, loading: false });
          isLoadingRef.current = false;
          // Si es la primera página y no hay resultados, limpiar las apuestas
          if (pager.page === 1) {
            setMyBets([]);
          }
          return;
        }

        setMyBets(prevBets => {
          // Si es la primera página, reemplazar; si no, agregar
          if (pager.page === 1) {
            return wagers;
          }
          return [...prevBets, ...wagers];
        });

        setPager({ page, pages, loading: false });
        isLoadingRef.current = false;
      })
      .catch(error => {
        console.error('Error fetching wagers:', error);
        setPager(prevPager => ({ ...prevPager, loading: false }));
        isLoadingRef.current = false;
      });
  }, [selectedStatus, selectedRange, pager.page]);

  React.useEffect(() => {
    const ref = myGamesRef.current;
    if (!ref) return;

    // Scroll event of my games con debounce
    const handleScroll = ev => {
      // Limpiar timeout anterior
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      // Debounce: esperar 150ms antes de procesar el scroll
      scrollTimeoutRef.current = setTimeout(() => {
        // Usar función de actualización para leer el estado más reciente
        setPager(prevPager => {
          // Evitar cargar más si ya está cargando, no hay más páginas, o ya se está cargando otra página
          if (isLoadingRef.current || prevPager.loading || prevPager.page >= prevPager.pages) {
            return prevPager;
          }

          // Verificar si llegamos al final del scroll
          const scrollThreshold = 150;
          const scrollPosition = ref.scrollTop + ref.offsetHeight;
          const scrollHeight = ref.scrollHeight;

          if (scrollPosition >= scrollHeight - scrollThreshold) {
            // Solo incrementar la página, el useEffect manejará el loading
            return {
              ...prevPager,
              page: prevPager.page + 1,
            };
          }

          return prevPager;
        });
      }, 150);
    };

    ref.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
        scrollTimeoutRef.current = null;
      }
      ref.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="panel-pickwin" style={{ background: 'white', color: '#333' }}>
      <div class="flex-row">
        <div class="flex-col">
          Estas son tus apuestas pendientes, tus nuevas apuestas las podrás revisar en el sportsbook
          en la sección "MIS APUESTAS"
        </div>
      </div>
      <div className="flex-row row-center">
        <div className="flex-col col-15">Estado:</div>
        <div className="flex-col">
          <select
            name="status"
            id="status"
            className="dropdownForm"
            style={{ marginBottom: '0px' }}
            onChange={handleChangeDropdown}
            defaultValue="1"
          >
            <option value="all">Todas</option>
            <option value="pending">Pendientes</option>
            <option value="win">Ganados</option>
            <option value="loss">Perdidos</option>
            <option value="push">Push</option>
            <option value="cancelled">Cancelados</option>
          </select>
        </div>
        <div className="flex-col col-15">Periodo:</div>
        <div className="flex-col">
          <select
            name="period"
            id="period"
            className="dropdownForm"
            style={{ marginBottom: '0px' }}
            onChange={handleChangeDropdown}
            defaultValue="all"
          >
            <option value="all">Todo</option>
            <option value="today">Hoy</option>
            <option value="week">Ultima semana</option>
            <option value="month">Ultimo mes</option>
            <option value="semester">Ultimos 6 meses</option>
            <option value="year">Ultimo año</option>
          </select>
        </div>
      </div>
      {!pager.loading && myBets.length === 0 && (
        <div className="flex-row row-center">
          <div className="flex-col text-center">No hay apuestas para mostrar</div>
        </div>
      )}

      <div className="my-games-content" ref={myGamesRef}>
        <div className="flex-row row-wrap">
          {myBets.map((bet, i) => (
            <WagerCard key={i} wager={bet} />
          ))}
        </div>
        {pager.loading && (
          <div className="flex-row">
            <div className="col text-center">Cargando...</div>
          </div>
        )}
      </div>
    </div>
  );
};

const WagerCard = ({ wager }) => {
  const [collapsed, setCollapsed] = React.useState(true);
  let classRisk = null;
  let classWin = null;
  let classBack = null;
  let classBorder = null;
  let icon = '';

  React.useEffect(() => {}, []);

  const statuses = {
    1: 'Pendiente',
    2: 'Ganada',
    3: 'Perdida',
    4: 'Push',
    5: 'Cancelada',
    6: 'Ganada por ¼',
    7: 'Perdida por ¼',
    8: 'Ganada por ¾',
    9: 'Perdida por ¾',
    10: 'No Bet',
    11: 'NA If Bets',
    12: 'Cambio de Pitcher',
    13: 'NA Short',
    14: 'NA Void',
  };

  switch (wager.status) {
    // PENDING

    case 'pending':
      classWin = styles.blue;
      classBack = styles.blueBack;
      classRisk = styles.purple;
      classBorder = styles.borderBlue;
      icon = 'ion-clock';
      break;
    // WIN, WIN BY 1/14, WIN BY 3/4
    case 'win':
      classWin = styles.green;
      classBack = styles.greenBack;
      classRisk = styles.black;
      classBorder = styles.borderGreen;
      icon = 'ion-trophy';
      break;
    // LOSS, LOSS BY 1/4, LOSS BY 3/4
    case 'loss':
      classWin = styles.red;
      classBack = styles.blackBack;
      classRisk = styles.red;
      classBorder = styles.borderRed;
      icon = 'ion-minus-circled';
      break;
    // PUSH Y CANCELADAS
    case 'push':
    case 'cancelled':
    default:
      classWin = styles.black;
      classBack = styles.blackBack;
      classRisk = styles.black;
      classBorder = styles.borderBlack;
      icon = 'ion-android-time';
      break;
  }

  function showBetDetail() {
    setCollapsed(!collapsed);
  }

  const getSportName = sportSysName => {
    const options = { name: '', icon: '' };
    // Normalizar el nombre del deporte para comparación
    const sportKey = sportSysName?.toLowerCase() || '';

    if (sportKey.includes('soccer') || sportKey.includes('football')) {
      options.icon = futbol;
      options.name = 'Fútbol';
    } else if (sportKey.includes('nfl') || sportKey.includes('american football')) {
      options.icon = americano;
      options.name = 'Fútbol Americano';
    } else if (sportKey.includes('nba') || sportKey.includes('basketball')) {
      options.icon = basketball;
      options.name = 'Basketball';
    } else if (sportKey.includes('mlb') || sportKey.includes('baseball')) {
      options.icon = baseball;
      options.name = 'Baseball';
    } else if (sportKey.includes('nhl') || sportKey.includes('hockey')) {
      options.icon = hockey;
      options.name = 'Hockey';
    }

    return options;
  };

  // Obtener el deporte del primer evento si existe, o usar wager.sports
  const firstEvent = wager.events && wager.events.length > 0 ? wager.events[0] : null;
  const sportKey = firstEvent?.sport_sys_name || wager.sports || '';
  const sport = getSportName(sportKey);
  // Construir el header con las nuevas propiedades
  const headerText = `#${wager.betslip_group_id || ''} - ${wager.placement_type ||
    ''} - ${wager.bet_type || ''} - ${wager.sports || ''}`.trim();

  const headerInfo = (
    <div>
      <div className={`${styles.itemTitle} ${styles.itemTitlePrincipal}`}>
        <div className={`${styles.itemIcons} ${classBorder}`}>
          <div className="flex-row row-center row-no-padding">
            <div className={`col-75 ${styles.flexCenter}`}>
              <i className={`${icon} ${classWin} ${styles.icon}`} />
              {sport.icon && <img src={sport.icon} style={{ height: '13px', width: 'auto' }} />}
              {headerText}
            </div>
            <div className="flex-col col-25 col-no-padding text-right">
              <span style={{ fontSize: 'xx-small' }}>{statuses[wager.status]}</span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.itemTitle} style={{ justifyContent: 'flex-start', padding: '0 5px' }}>
        <div className={classRisk}>
          <div>Arriesga: ${numeral(wager.risk || 0).format('0,0')} mxn</div>
        </div>
        &nbsp;&nbsp; - &nbsp;&nbsp;
        <div className={classWin}>
          <div>Gana: ${numeral(wager.win || 0).format('0,0')} mxn</div>
        </div>
      </div>
    </div>
  );

  // Verificar si hay eventos disponibles
  const events = wager.events || [];

  if (events.length === 0) {
    return null;
  }

  if (collapsed === false) {
    return (
      <div className={`${styles.boxContainer} col-50`}>
        <div className={styles.item} onClick={() => showBetDetail()}>
          {headerInfo}
          <div className={styles.betInfo}>
            <div className="flex-row row-center row-no-padding" style={{ marginBottom: '5px' }}>
              <div className="flex-col col-70 col-no-padding">
                <strong>BOLETO</strong> #{wager.betslip_group_id}
                <br />
                <strong>{moment(wager.created).format('YYYY-MM-DD HH:mm:ss')}</strong>
              </div>
            </div>

            {events.map((event, index) => {
              return (
                <div key={index} className={styles.gameRow}>
                  <div className="flex-col col-no-padding col-70 overflow-words">
                    {wager.live_fixtures && wager.live_fixtures.length > 0 && (
                      <a
                        className={`${styles.statusGame} ${styles.gameFollow}`}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          e.nativeEvent.preventDefault();
                          e.nativeEvent.stopPropagation();
                        }}
                      >
                        <i className="icon ion-eye" />
                      </a>
                    )}
                    <strong>
                      {event.sport_sys_name} {event.tournament_name}
                    </strong>{' '}
                    {event.match_title} {event.market && `- ${event.market}`}
                  </div>
                  <div className="flex-col col-no-padding text-right">
                    {moment(event.event_date).format('DD MMM YY HH:mm')}
                  </div>
                </div>
              );
            })}
          </div>

          <div className={styles.arrow}>
            <i className="ion-ios-arrow-up" />
          </div>
        </div>
      </div>
    );
  } else {
    const firstEvent = events[0];
    const secondEvent = events[1];

    return (
      <div className={`${styles.boxContainer} col-50`}>
        <div className={`${styles.item}`} onClick={() => showBetDetail()}>
          {headerInfo}
          <div className={styles.betInfo}>
            <div className={styles.gameRowFull}>
              <div className="overflow-words">
                {firstEvent.sport_sys_name} - {firstEvent.tournament_name}
                {firstEvent.match_title}
                {firstEvent.market}
              </div>
            </div>

            {secondEvent && (
              <div className={styles.gameRowFull}>
                <div className="overflow-words">
                  {secondEvent.sport_sys_name} - {secondEvent.tournament_name}
                  {secondEvent.match_title}
                  {secondEvent.market}
                  <br />
                  ...
                </div>
              </div>
            )}
          </div>

          <div className={styles.arrow}>
            <i className="ion-ios-arrow-down" />
          </div>
        </div>
      </div>
    );
  }
};

export default OldWagers;
